import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LogIn, LogOut, Activity } from "lucide-react";

const fmtTime = (s) => (s ? new Date(s).toLocaleString() : "—");

export default function LoginActivity() {
  const [data, setData] = useState({ events: [], summary: [] });
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/login-events").then((r) => setData(r.data)).finally(() => setLoading(false));
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="login-activity-page">
      {/* Per-user summary */}
      <div className="overline" style={{ fontSize: 10, marginBottom: 10 }}>Per-user summary</div>
      <div className="card-ledger overflow-hidden mb-8">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr style={{ background: "var(--surface-2)" }}>
            {["User", "Logins", "Logouts", "Last login", "Last logout"].map((h, i) => (
              <th key={i} className="overline" style={{ fontSize: 10, padding: "12px 16px", textAlign: i < 1 ? "left" : "left", borderBottom: "1px solid var(--border)" }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {data.summary.length === 0 ? (
              <tr><td colSpan={5} style={{ padding: 24, textAlign: "center", color: "var(--text-2)" }}>{loading ? "Loading…" : "No login activity yet."}</td></tr>
            ) : data.summary.map((s) => (
              <tr key={s.user_id} style={{ borderBottom: "1px solid var(--border)" }} data-testid={`login-summary-${s.user_id}`}>
                <td style={{ padding: "14px 16px", fontWeight: 600, fontSize: 14 }}>{s.user_name || "—"}</td>
                <td style={{ padding: "14px 16px", fontSize: 13 }} className="font-mono-data">{s.logins}</td>
                <td style={{ padding: "14px 16px", fontSize: 13 }} className="font-mono-data">{s.logouts}</td>
                <td style={{ padding: "14px 16px", fontSize: 13, color: "var(--text-2)" }}>{fmtTime(s.last_login)}</td>
                <td style={{ padding: "14px 16px", fontSize: 13, color: "var(--text-2)" }}>{fmtTime(s.last_logout)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Recent events */}
      <div className="overline" style={{ fontSize: 10, marginBottom: 10 }}>Recent events</div>
      <div className="card-ledger overflow-hidden">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr style={{ background: "var(--surface-2)" }}>
            {["Event", "User", "When", "IP"].map((h, i) => (
              <th key={i} className="overline" style={{ fontSize: 10, padding: "12px 16px", textAlign: "left", borderBottom: "1px solid var(--border)" }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {data.events.length === 0 ? (
              <tr><td colSpan={4} style={{ padding: 24, textAlign: "center", color: "var(--text-2)" }}><Activity size={24} style={{ margin: "0 auto 8px" }} />{loading ? "Loading…" : "No events recorded."}</td></tr>
            ) : data.events.map((e) => (
              <tr key={e.id} style={{ borderBottom: "1px solid var(--border)" }} data-testid={`login-event-${e.id}`}>
                <td style={{ padding: "12px 16px" }}>
                  <span className="tag" style={{ background: "var(--surface-2)", borderColor: "var(--border)", color: e.event === "login" ? "var(--primary)" : "var(--text-2)" }}>
                    {e.event === "login" ? <LogIn size={11} /> : <LogOut size={11} />} {e.event}
                  </span>
                </td>
                <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 600 }}>{e.user_name || "—"}</td>
                <td style={{ padding: "12px 16px", fontSize: 13, color: "var(--text-2)" }}>{fmtTime(e.at)}</td>
                <td style={{ padding: "12px 16px", fontSize: 13, color: "var(--text-2)" }} className="font-mono-data">{e.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
